import React from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  SelectChangeEvent
} from '@mui/material';
import { ExpandMore as ExpandMoreIcon } from '@mui/icons-material';
import { FormState } from '../pages/BorrowerForm';

interface DownpaymentAccordionProps {
  formState: FormState;
  expanded: boolean;
  onChange: () => void;
  handleDownpaymentSourceChange: (e: SelectChangeEvent) => void;
  handleDownpaymentSourceNotesChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleGiftorChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleInheritingFromChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleDownpaymentAmountChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  StyledFormControl: typeof FormControl;
}

const DownpaymentAccordion: React.FC<DownpaymentAccordionProps> = ({
  formState,
  expanded,
  onChange,
  handleDownpaymentSourceChange,
  handleDownpaymentSourceNotesChange,
  handleGiftorChange,
  handleInheritingFromChange,
  handleDownpaymentAmountChange,
  StyledFormControl
}) => {
  return (
    <Accordion 
      expanded={expanded}
      onChange={onChange}
      sx={{ mb: 0.5, backgroundColor: 'rgba(240, 245, 250, 0.9)' }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="downpayment-content"
        id="downpayment-header"
        sx={{ backgroundColor: 'rgba(0, 0, 0, 0.03)', minHeight: '42px', '& .MuiAccordionSummary-content': { margin: '8px 0' } }}
      >
        <Typography variant="h5" gutterBottom sx={{ mb: 0 }} fontSize="1.1rem">
          Downpayment
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ pt: 1, pb: 0.5 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={6}>
            <StyledFormControl fullWidth>
              <InputLabel id="downpayment-source-label">Downpayment Source</InputLabel>
              <Select
                labelId="downpayment-source-label"
                id="downpayment-source"
                value={formState.downpaymentSource || ''}
                onChange={handleDownpaymentSourceChange}
                label="Downpayment Source"
              >
                <MenuItem value="Savings">Savings</MenuItem>
                <MenuItem value="Gift">Gift</MenuItem>
                <MenuItem value="Inheritance">Inheritance</MenuItem>
                <MenuItem value="Sale of Asset">Sale of Asset</MenuItem>
                <MenuItem value="Other">Other</MenuItem>
              </Select>
            </StyledFormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <TextField
              fullWidth
              id="downpayment-source-notes"
              label="Downpayment Source Notes"
              value={formState.downpaymentSourceNotes || ''}
              onChange={handleDownpaymentSourceNotesChange}
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <TextField
              fullWidth
              id="giftor"
              label="Giftor"
              value={formState.giftor || ''}
              onChange={handleGiftorChange}
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <TextField
              fullWidth
              id="inheriting-from"
              label="Inheriting From"
              value={formState.inheritingFrom || ''}
              onChange={handleInheritingFromChange}
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <TextField
              fullWidth
              id="downpayment-amount"
              label="Downpayment Amount"
              value={formState.downpaymentAmount || ''}
              onChange={handleDownpaymentAmountChange}
              variant="outlined"
              InputProps={{
                startAdornment: <span>$</span>,
              }}
              inputProps={{
                inputMode: 'decimal',
                pattern: '[0-9]*(\\.[0-9]{0,2})?'
              }}
            />
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

export default DownpaymentAccordion;
